<template>
  <div class="mb-4">
    <div class="relative float-label-input w-full" :class="{ 'is-error': errorMessage }">
      <input
        v-if="props.isMask"
        v-maska
        data-maska="###-###-##-##"
        :disabled="props.disabled"
        autocomplete="off"
        :type="props.type"
        :name="props.name"
        v-model.trim="value"
        placeholder=" "
        class="form-element"
        :class="{ 'pr-4': !isHaveSlot }"
      />
      <input
        @change="$emit('update:modelValue')"
        v-if="!props.isMask"
        :disabled="props.disabled"
        autocomplete="off"
        :type="props.type"
        :name="props.name"
        v-model.trim="value"
        placeholder=" "
        class="form-element"
        :class="{ 'pr-4': !isHaveSlot }"
      />
      <label
        for="name"
        class="absolute absolute-label top-1/2 -translate-y-1/2 left-[16px] font-medium text-gray-500 pointer-events-none transition duration-200 ease-in-outbg-white"
        >{{ props.label }}</label
      >

      <div ref="group" class="icon">
        <slot name="icon" />
      </div>
    </div>
    <span v-if="errorMessage" class="text-xs text-red-300 font-medium">{{ errorMessage }}</span>
  </div>
</template>

<script setup lang="ts">
import { useField } from 'vee-validate'
import { computed, ref } from 'vue'
import { vMaska } from 'maska'
const props = defineProps(['error', 'label', 'name', 'type', 'disabled', 'isMask', 'info'])
const group = ref()
const isHaveSlot = computed(() => {
  if (!group.value?.children.length) return false
  return true
})

const { value, errorMessage } = useField(() => props.name)
</script>
